import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface BudgetAllocatorPanelProps {
  recommendations: Record<string, number> | null | undefined;
  loading?: boolean;
}

const platformLabels: Record<string, string> = {
  instagram: "Instagram",
  tiktok: "TikTok",
  youtube: "YouTube",
  facebook: "Facebook",
};

export function BudgetAllocatorPanel({ recommendations, loading }: BudgetAllocatorPanelProps) {
  const entries = Object.entries(recommendations ?? {});
  const total = entries.reduce((sum, [, amount]) => sum + amount, 0);

  return (
    <Card className="space-y-4 border-border/70 bg-background/40 p-4">
      <div>
        <p className="text-sm font-semibold text-foreground">Budget Allocator</p>
        <p className="text-xs text-muted-foreground">Where to spend the next dollars.</p>
      </div>
      {loading ? (
        <p className="text-xs text-muted-foreground">Calculating…</p>
      ) : entries.length ? (
        <div className="space-y-3">
          {entries.map(([platform, amount]) => {
            const percent = total ? Math.round((amount / total) * 100) : 0;
            return (
              <div key={platform}>
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>{platformLabels[platform] ?? platform}</span>
                  <span>${amount.toFixed(0)} · {percent}%</span>
                </div>
                <Progress value={percent} className="mt-1" />
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">No recommendations yet.</p>
      )}
    </Card>
  );
}
